import React, { createContext, useReducer, useContext } from 'react';

// Initial state for the context
const initialState = {
  activeTab: 1,
  campaignSidebarTracking: 0,
  adGroupSidebarTracking: 0,
  campaignSortConfig: ['DRAFT', 'DELIVERING', 'INACTIVE', 'ADGROUPS_NOT_RUNNING'],
  adGroupSortConfig: ['DRAFT', 'DELIVERING', 'INACTIVE', 'CREATIVES_NOT_RUNNING', 'READY_TO_DELIVER', 'OTHER'],
  selectedCampaignId: "",
  isCampaignEdit: false,
  isCampaignDraft: false,
  isAdGroupEdit:false,
  isAdGroupDraft:false,
  isCreativeEdit:false,
  campaignEditData: {},
  campaignDraftData: {},
  campaignEditApiData: [],
  adGroupEditData:{},
  adGroupDraftData:{},
  adGroupEditApiData:[],
  creativeEditData:{},
  walletBalance:0,
  reportTableTab: 1,
  showAPIFailToast: false,
  walletDetails:{},
  dspData:{},
  showDashboard: true,
  user_filters: []
};

// Define the reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_ACTIVE_TAB':
      return { ...state, activeTab: action.payload };
    case 'UPDATE_CAMPAIGN_SIDEBAR_TRACKING':
      return { ...state, campaignSidebarTracking: action.payload };
    case 'UPDATE_AD_GROUP_SIDEBAR_TRACKING':
      return { ...state, adGroupSidebarTracking: action.payload };
    case 'UPDATE_CAMPAIGN_SORT_CONFIG':
      return { ...state, campaignSortConfig: action.payload };
    case 'UPDATE_AD_GROUP_SORT_CONFIG':
      return { ...state, adGroupSortConfig: action.payload };
    case 'UPDATE_SELECTED_CAMPAIGN_ID':
      return { ...state, selectedCampaignId: action.payload };
    case 'UPDATE_CAMPAIGN_EDIT':
      return { ...state, isCampaignEdit: action.payload };
    case 'UPDATE_CAMPAIGN_EDIT_DATA':
      return { ...state, campaignEditData: action.payload };
    case 'UPDATE_CAMPAIGN_DRAFT':
      return { ...state, isCampaignDraft: action.payload };
    case 'UPDATE_CAMPAIGN_DRAFT_DATA':
      return { ...state, campaignDraftData: action.payload };
    case 'UPDATE_CAMPAIGN_EDIT_API_DATA':
      return { ...state, campaignEditApiData: action.payload };
    case 'UPDATE_ADGROUP_DRAFT':
      return { ...state, isAdGroupDraft: action.payload };
    case 'UPDATE_ADGROUP_DRAFT_DATA':
      return { ...state, adGroupDraftData: action.payload };
    case 'UPDATE_ADGROUP_EDIT':
      return { ...state, isAdGroupEdit: action.payload };
    case 'UPDATE_CREATIVE_EDIT':
      return { ...state, isCreativeEdit: action.payload };
    case 'UPDATE_ADGROUP_EDIT_DATA':
      return { ...state, adGroupEditData: action.payload };
    case 'UPDATE_ADGROUP_EDIT_API_DATA':
      return { ...state, adGroupEditApiData: action.payload };
    case 'UPDATE_CREATIVE_EDIT_DATA':
      return { ...state, creativeEditData: action.payload };
    case 'UPDATE_WALLET_BALANCE':
      return { ...state, walletBalance: action.payload };
    case 'UPDATE_REPORT_TABLE_TAB':
      return { ...state, reportTableTab: action.payload };
    case 'UPDATE_API_FAIL_TOAST_STATUS':
      return { ...state, showAPIFailToast: action.payload };
    case 'UPDATE_WALLET_DETAILS_DATA':
      return { ...state, walletDetails: action.payload };
    case 'UPDATE_DSP_DATA':
      return { ...state, dspData: action.payload };
    case 'UPDATE_DASHBOARD_STATE':
      return { ...state, showDashboard: action.payload };
      case 'UPDATE_USER_FILTERS_STATE':
      return { ...state, user_filters: action.payload };
    default:
      return state;
  }
};

// Create the context
const AmzDspContext = createContext();

// Create a custom hook to use the context
const useAmzDspContext = () => {
  const context = useContext(AmzDspContext);
  if (!context) {
    throw new Error('useAmzDspContext must be used within a AmzDspProvider');
  }
  return context;
};

// Create the provider component
const AmzDspProvider = ({ children }) => {
  const [amzDspState, amzDspDispatch] = useReducer(reducer, initialState);

  return <AmzDspContext.Provider value={{ amzDspState, amzDspDispatch }}>{children}</AmzDspContext.Provider>;
};

export { AmzDspProvider, useAmzDspContext };
